import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const SMSLinks00Table: GenericTableSchemaInterface = {
  id: 'sms-links-00',
  name: 'SMS Links 00',
  description:
    'This table contains data regarding how many people were shown and clicked URLs via SMS',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: VarKey.OrgName
    },
    c02: {
      name: 'Facility ID',
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: 'Referral Program Shown'
    },
    c04: {
      name: 'Google Review Shown'
    },
    c05: {
      name: 'Auction Website Shown'
    },
    c06: {
      name: 'About Storage Company Shown'
    },
    c07: {
      name: 'Careers Shown'
    },
    c08: {
      name: 'Size Visuals Shown'
    },
    c09: {
      name: 'Pay Online - Autopay Shown'
    },
    c10: {
      name: 'Pay Online - Pay Bill Shown'
    },
    c11: {
      name: 'Account Login - Credit Debit Shown'
    },
    c12: {
      name: 'Account Login - Autopay Shown'
    },
    c13: {
      name: 'Account Login - Password Reset Shown'
    },
    c14: {
      name: 'Account Login - Update Billing Info Shown'
    },
    c15: {
      name: 'Account Login - Create Login Shown'
    },
    c16: {
      name: 'Account Login - Username Shown'
    },
    c17: {
      name: 'Account Login - Reservations Shown'
    },
    c18: {
      name: 'Account Login - Pay Bill Shown'
    },
    c19: {
      name: 'Account Login - Update Contact Info Shown'
    },
    c20: {
      name: 'Insurance Website Shown'
    },
    c21: {
      name: 'Inventory Shown'
    },
    c22: {
      name: 'Vehicle Inventory Shown' // same as inventory link for now
    },
    c23: {
      name: 'Referral Program Clicked'
    },
    c24: {
      name: 'Google Review Clicked'
    },
    c25: {
      name: 'Auction Website Clicked'
    },
    c26: {
      name: 'About Storage Company Clicked'
    },
    c27: {
      name: 'Careers Clicked'
    },
    c28: {
      name: 'Size Visuals Clicked'
    },
    c29: {
      name: 'Pay Online - Autopay Clicked'
    },
    c30: {
      name: 'Pay Online - Pay Bill Clicked'
    },
    c31: {
      name: 'Account Login - Credit Debit Clicked'
    },
    c32: {
      name: 'Account Login - Autopay Clicked'
    },
    c33: {
      name: 'Account Login - Password Reset Clicked'
    },
    c34: {
      name: 'Account Login - Update Billing Info Clicked'
    },
    c35: {
      name: 'Account Login - Create Login Clicked'
    },
    c36: {
      name: 'Account Login - Username Clicked'
    },
    c37: {
      name: 'Account Login - Reservations Clicked'
    },
    c38: {
      name: 'Account Login - Pay Bill Clicked'
    },
    c39: {
      name: 'Account Login - Update Contact Info Clicked'
    },
    c40: {
      name: 'Insurance Website Clicked'
    },
    c41: {
      name: 'Inventory Clicked'
    },
    c42: {
      name: 'Vehicle Inventory Clicked' // same as inventory link for now
    },
    c43: {
      name: 'SELECT Store Shown'
    },
    c44: {
      name: 'SELECT Store Clicked'
    },
    c45: {
      name: 'Account Login - Cancel Service Shown'
    },
    c46: {
      name: 'Account Login - Cancel Service Clicked'
    },
    c47: {
      name: 'Mobile App URL Shown'
    },
    c48: {
      name: 'Mobile App URL Clicked'
    }
  }
}
